<template>
  <section class="checks-group">
    <Checkbox
      v-for="(item, index) in getCheckboxes()"
      :id="index"
      :key="index"
      :label="item.label"
      :element="item.element"
      :disabled="getDisabled(index)"
      :active="item.active"
      :cards="item.cards"
      :metadata="item.metadata"
      @emit-model="getModel($event)"
    />
  </section>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Models
import model from '@/content-structure/models';

export default {
  name: 'CheckboxGroup',

  components: {
    Checkbox: () => import('./Checkbox.vue'),
  },

  data() {
    return {
      checkList: model.checkList,
    };
  },

  computed: {
    ...mapGetters(['activeChecks']),
  },

  methods: {
    ...mapActions(['getActiveChecks']),

    getModel(e) {
      let data;
      if (this.activeChecks.length > 0) {
        data = this.activeChecks.filter((item) => item.id !== e.id);
      } else {
        data = this.checkList.filter((item) => item.id !== e.id);
      }

      data.push(e);
      const check = data.filter((item) => item.active).length;

      if (check > 2) {
        return;
      }

      this.getActiveChecks(data.sort((a, b) => a.id - b.id));
    },

    getDisabled(id) {
      if (this.activeChecks.filter((item) => item.active).length === 2) {
        const data = this.activeChecks.filter((item) => !item.active)[0];
        if (data.id === id) {
          return true;
        }
        return false;
      }
    },

    getCheckboxes() {
      return (this.activeChecks.length > 0)
        ? this.activeChecks
        : this.checkList;
    },
  },
};
</script>

<style lang="scss" scoped>
.checks-group {
  background: $white;
  border: 1px solid #707070;
  padding: rem(12) rem(5) rem(12) rem(24);
  border-radius: 2px;
  @include flexbox(center, flex-start);

  &::v-deep {
    .check {
      margin-right: rem(10);

      &:not(:first-child) {
        margin-left: rem(18) !important;
      }
    }
  }
}
</style>
